import React from "react";

import InvestigationInputItem from "./InvestigationInputItem";
import { Box, Typography } from '@mui/material';
import "../../../css/report.css"

function InvestigationTypeBlock(props){

  let investigationType = ""
  switch (props.typeOfInvestigation) {
    case "blood": investigationType = "Blood Tests"
      break;

    case "urine": investigationType = "Urine Tests"
    break;

    case "stool": investigationType = "Stool Tests"
          break;

    case "imaging": investigationType = "Radiological Investigations"
    break;

    case "endoscopy": investigationType = "Endoscopic Investigations"
    break;
 
    default: investigationType = "Other Investigations"
      break;
  }

    let investigationsForBlock= props.listOfInvestigations.map((eachInvestigation,key)=>
        <InvestigationInputItem 
        typeOfInvestigation={props.typeOfInvestigation} 
      investigationName={eachInvestigation}
      initialValues={props.initialValues} 
      displayClass={(props.NG12Investigations.includes(eachInvestigation) ?"NG12investigation" : (props.showAll ? "notNG12Investigation" : "hidden"))}
        key={key}
        />)
  let displayOption =(props.listOfInvestigations.length===0 ? "hidden" :"investigationsBlock")       

return(
<Box id={displayOption} sx={{border:"solid lightGrey", borderRadius:"5px", padding:1}}>
<Typography variant="h6" >{investigationType}</Typography>

{investigationsForBlock}

</Box>
)
}

export default InvestigationTypeBlock

